module.exports = __webpack_public_path__ + "img/client_rabbit.99a82add.svg";